import styled from '@emotion/styled'

const ButtonContainer = styled('button')`
  ${({
    theme: {
      colors: {
        components: { button }
      }
    }
  }) => `
    all: unset;
    color: ${button.color};
    border: 1px solid ${button.border};
    text-transform: uppercase;
    padding: 10px 25px;
    border-radius: 5px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: ${button.hover.background};;
      color: ${button.hover.color};
    }
  `}
`

const Button = ({ children, ...props }) => {
  return <ButtonContainer {...props}>{children}</ButtonContainer>
}

export default Button
